import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';

import { Link } from 'react-router-dom';
import { Image,  
  // Media
 } from 'react-bootstrap';

import styles from './contacts.module.scss';
import Text from 'src/components/text';

class ContactRow extends React.Component {
  constructor(props){
    super(props);

    this.handleContactClick = this.handleContactClick.bind(this);
  }

  renderName(){
    return `${this.props.contact.firstName || ''} ${this.props.contact.lastName || ''}`
  }

  renderInitials(){
    let initial = '';

    if(this.props.contact.firstName){
      initial = this.props.contact.firstName.charAt(0);
    }

    if(this.props.contact.lastName){
      initial = initial + this.props.contact.lastName.charAt(0);
    }

    return initial.toUpperCase();
  }

  handleContactClick() {
    if(this.props.onSelection) {
      this.props.onSelection(this.props.contact);
    }
  }

  render() {
    return (
      <div>
        {this.props.editable && this.renderContact()}
        {!this.props.editable && this._wrapContactWithLink(this.renderContact())}
      </div>
    )
      
  }

  _wrapContactWithLink(contact) {
    var indexLetter = "#";

    if (this.props.contact && this.props.contact.firstName) {
      indexLetter = this.props.contact.firstName.charAt(0).toUpperCase();
      if (!indexLetter.match(/[a-z]/i)) {
        indexLetter = '#';
      }
    }

    var url = this.props.url;

    if(!url){
      url = `/rolodex/contacts/${this.props.contact.id}`;
    }

    return (
      <div
        className={cx(styles.contact, 'contact', this.props.className)} 
        >
        {contact}
      </div>
    )
  }

  renderContact() {
    return (
      <>

      <div key={this.props.contact.id} className={cx(styles.inner, { [styles.disabled]: this.props.disabled })} onClick={this.handleContactClick}>
        <span className={styles.left}>
          <div className={styles.iconContainer}>
            {!this.props.contact.icon &&
              <div className={styles.contactAvatar}> 
              <i className='paperflite-user-settings'/>
              </div>}
            {this.props.contact.icon &&
              <Image className={styles.contactIcon} src={this.props.contact.icon.thumbnail} circle />}
          </div>
        </span>
        <span className={styles.body}>
          <div className={styles.bodyInner}>
            <div className={styles.contactName}>
              <Text text={this.renderName(this.props.contact)} lines={1} />
            </div>
            <div className={styles.contactTitle}>
              <Text text={this.props.contact.email || 'No Details'} />
            </div>
          </div>
        </span>
        {this.props.contact.sources && this.props.contact.sources.length > 0 && !this.props.editable &&
          <span className={styles.right}>
            <div className={styles.source}>{this.props.contact.sources && this.props.contact.sources[0]}</div>
            {this.props.contact.sources && this.props.contact.sources.length > 1 && <div className={styles.etc}>...</div>}
          </span>
        }
        {this.props.editable &&
          <span className={cx(styles.rightSelect, styles.selectButton)}>
            <i className={cx(`${this.props.selected ? 'fa-solid fa-circle-check' : `fa-regular fa-circle ${styles.unselected}` }`)} aria-hidden="true"></i>
          </span>
        }
      </div>
      {this.props.showBorders && <div className={styles.line}/>}
      </>
    )
  }
}

export default ContactRow;